import { Box, useTheme } from "@mui/material";
import type { FC, RefObject } from "react";
import type { DashboardType } from "web_myplann/Dashboard/Components/DashboardTitleCard";
import { useDashboardStatusBarColor } from "web_myplann/Dashboard/Hooks/useDashboardStatusBarColor";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import NavigationHeader from "web_myplann/Shared/Header/NavigationHeader";
import { useScrolledPastTop } from "web_myplann/Shared/Hooks/useScrolledPastTop";

type Props = {
	heroRef: RefObject<HTMLElement | null>;
	dashboard: DashboardType;
};

export const DashboardDetailStickyHeader: FC<Props> = ({
	heroRef,
	dashboard,
}) => {
	const theme = useTheme();
	const scrolledPast = useScrolledPastTop(heroRef, {
		root: null,
		topOffsetPx: theme.navigation.header.height,
	});

	useDashboardStatusBarColor(scrolledPast ? undefined : dashboard.gradientFrom);

	return (
		<Box
			position="fixed"
			top={0}
			left={0}
			right={0}
			zIndex={theme.zIndex.appBar}
			bgcolor={scrolledPast ? theme.palette.surface.muted : "transparent"}
			sx={{ transition: "background-color 0.2s" }}
		>
			<NavigationHeader
				title={scrolledPast ? dashboard.type : ""}
				defaultRoute={Routing.Dashboard.path()}
				bgColor="transparent"
				backIconColor={
					scrolledPast
						? theme.palette.grey[900]
						: theme.palette.darkmodeText.white
				}
			/>
		</Box>
	);
};
